import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { INTL_BOOK_RE, INTL_ORIGIN, RU_ORIGIN } from "@/lib/bookI18n";

/**
 * biopeptideplus.com serves only the translated handbook (/en|es|fr|de|th/book…);
 * everything else lives on biopeptideplus.ru. nginx does the same with 301s —
 * this covers in-app navigation (e.g. a header link clicked on .com).
 */
export const DomainGuard = () => {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    const h = window.location.hostname;
    const intl = INTL_BOOK_RE.test(pathname);
    if (h.endsWith("biopeptideplus.com") && !intl) window.location.replace(RU_ORIGIN + pathname + search + hash);
    else if (h.endsWith("biopeptideplus.ru") && intl) window.location.replace(INTL_ORIGIN + pathname + search + hash);
  }, [pathname, search, hash]);
  return null;
};
